/**
 *
 * Badge
 *
 */

import React, { FunctionComponent } from 'react';
import { StyledBadge } from './styledComponents';

interface IProps {
  icon?: React.ReactElement;
  accent?: boolean;
  active?: boolean;
  className?: string;
}

const Badge: FunctionComponent<IProps> = ({
  children,
  icon,
  accent,
  className,
  active,
}) => {
  return (
    <StyledBadge className={`${accent ? 'accent' : ''} ${active ? 'active' : ''} ${className}`}>
      {icon && <div className="icon">{icon}</div>}
      <div className="txt">{children}</div>
    </StyledBadge>
  );
};

export default Badge;
